import { Text, View } from '@react-pdf/renderer';

import { usePDFContext } from '../../PDFProvider';
import { styles } from './styles';

export function QuoteTotal() {
  const { formattedQuoteTotal } = usePDFContext();

  if (!formattedQuoteTotal) {
    return null;
  }

  return (
    <View style={[styles.row]}>
      <View style={styles.row}>
        <View style={styles.halfRow}>
          <Text>
            <Text style={styles.bold}>NOTE:</Text> Quote total is based on the
            first quantity of each line.
          </Text>
        </View>
        <View style={[styles.halfRow, styles.textRight, styles.bold]}>
          <Text>Quote Total: {formattedQuoteTotal}</Text>
        </View>
      </View>
    </View>
  );
}
